import OlControl from 'ol/control/Control'
import OlExtElement from 'ol-ext/util/element'
import { getZoomForScale, getResolutionForScale, getScaleForResolution } from '../services/scales-service'

class ControlZoomScaleResolution extends OlControl {
  constructor (options) {
    if (!options) options = {}

    const element = OlExtElement.create('div', {
      className: 'zoom-scale-resolution-control ol-unselectable ol-control',
    })

    super({
      element,
      target: options.target,
    })
    this.viewer = options.viewer || null
    this.animate = options.animate || false
    this.mapView = this.viewer.getMap().getView()
    this.baseResolution = this.mapView.getResolutionForZoom(0) || 156412.00

    this.displayLabel = options.displayLabel || '' // Libbéle au choix
    this.zoomMollette = false
    this.dpi = options.dpi
    this.selectElement = OlExtElement.create('select', {
      className: 'scale-select',
      parent: element,
    })

    this.zoomLevels = []
    this.tileSize = options.tileSize || 256
    if (options.list) {
      this.displayMode = options.list.mode
      options.list.range.forEach(scale => {
        const zoom = getZoomForScale(this.mapView, scale, this.dpi)
        let value = null
        if (this.displayMode === 'scale') {
          value = scale
        }
        if (this.displayMode === 'zoom') {
          value = zoom
        }
        if (this.displayMode === 'resolution') {
          value = getResolutionForScale(this.mapView, scale, this.dpi)
        }
        this.zoomLevels.push({ zoom, value })
      })
    } else {
      // Paramétrage d'affichage : "scale", "zoom", "resolution"
      this.displayMode = options.displayMode || 'zoom' // Valeurs possibles: 'scale', 'zoom', 'resolution'
      // Generer les niveau de zoom
      const minZoom = this.mapView.getMinZoom()
      const maxZoom = this.mapView.getMaxZoom()
      for (let i = minZoom; i <= maxZoom; i++) {
        if (this.displayMode === 'resolution') {
          const resolution = this.mapView.getResolutionForZoom(i)
          this.zoomLevels.push({ zoom: i, value: resolution })
        } else if (this.displayMode === 'scale') {
          const resolution = this.mapView.getResolutionForZoom(i)
          const scale = getScaleForResolution(this.mapView, resolution, this.dpi, false)
          this.zoomLevels.push({ zoom: i, value: scale })
        } else {
          this.zoomLevels.push({ zoom: i, value: i })
        }
      }
    }
    // Ajouter les options dans la liste déroulante

    // par defaut
    const option = document.createElement('option')
    option.value = -1
    this.selectElement.appendChild(option)
    this.zoomLevels.forEach(level => {
      const option = document.createElement('option')
      option.value = level.zoom
      if (this.displayMode === 'scale') {
        option.textContent = this.displayLabel + `1:${level.value}`
      }
      if (this.displayMode === 'zoom') {
        option.textContent = this.displayLabel + level.value
      }
      if (this.displayMode === 'resolution') {
        option.textContent = this.displayLabel + `${level.value} m/pixel`
      }
      this.selectElement.appendChild(option)
    })
    // Mettre à jour l'affichage du contrôle
    this.mapView.on('change:resolution', this.updateDisplay.bind(this))
    // Événement de sélection
    this.selectElement.addEventListener('change', this.onZoomChange.bind(this))
  }

  // Mise à jour de l'affichage du contrôle
  updateDisplay ({ target: view }) {
    if (this.zoomMollette) {
      return
    }
    this.zoomMollette = false
    // const currentZoom = Math.floor(view.getZoom())
    const currentZoom = view.getZoom()
    const currentResolution = view.getResolutionForZoom(currentZoom)
    const getCurrentScale = Math.round(getScaleForResolution(this.mapView, currentResolution, this.dpi, false))
    const selectedLevel = this.zoomLevels.find(level => level.zoom === currentZoom)
    if (selectedLevel) {
      this.selectElement.value = selectedLevel?.zoom
    } else {
      if (this.displayMode === 'scale') {
        this.selectElement[0].value = getCurrentScale
        this.selectElement[0].textContent = this.displayLabel + `1:${getCurrentScale}`
        this.selectElement.value = getCurrentScale
      }
      if (this.displayMode === 'zoom') {
        this.selectElement[0].value = currentZoom
        this.selectElement[0].textContent = this.displayLabel + currentZoom
        this.selectElement.value = currentZoom
      }
      if (this.displayMode === 'resolution') {
        this.selectElement[0].value = currentResolution
        this.selectElement[0].textContent = this.displayLabel + `${currentResolution} m/pixel`
        this.selectElement.value = currentResolution
      }
    }
  }

  // Changement de zoom via la liste déroulante
  onZoomChange (event) {
    this.zoomMollette = true
    // let value = parseInt(event.target.value)
    let value = event.target.value
    const selectedLevel = this.zoomLevels.find(level => (level.zoom).toString() === value)
    // this.selectElement.value = value

    if (this.displayMode === 'scale') {
      this.viewer.setScale(selectedLevel.value, this.animate)
    } else {
      value = this.displayMode === 'zoom' ? (this.baseResolution / Math.pow(2, selectedLevel.value) * 100) / 100 : selectedLevel.value
      const scale = getScaleForResolution(this.mapView, value, this.dpi, false)
      this.viewer.setScale(scale, this.animate)
    }
    this.zoomMollette = false
  }
}

export default ControlZoomScaleResolution
